var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "vx-card" },
        [
          _c("ConfigParamsHeader", {
            attrs: {
              application: _vm.application,
              "selected-user-id": _vm.selectedUserId,
              "is-super-admin": _vm.isSuperAdmin
            },
            on: {
              "update:application": _vm.onApplicationChange,
              "update:selectedUserId": _vm.onUserChange
            }
          }),
          _c(
            "div",
            {
              staticClass:
                "vx-card__collapsible-content vs-con-loading__container"
            },
            [
              _c("div", { staticClass: "vx-card__body" }, [
                _vm.error
                  ? _c("div", { staticClass: "alert alert-danger mb-3" }, [
                      _vm._v(" " + _vm._s(_vm.error) + " ")
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "config-params-panels" }, [
                  _c(
                    "div",
                    { staticClass: "config-params-panels__tree" },
                    [
                      _c("ConfigParamsTree", {
                        attrs: {
                          "tree-data": _vm.treeData,
                          "is-loading": _vm.isLoadTree,
                          "selected-id": _vm.selectedNodeId,
                          "is-super-admin": _vm.isSuperAdmin
                        },
                        on: {
                          "select-item": _vm.onSelectItem,
                          "context-action": _vm.onContextAction
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "config-params-panels__content" },
                    [
                      _vm.isLoadingConfigurations
                        ? _c(
                            "div",
                            { staticClass: "demo-inline-spacing" },
                            [
                              _c("b-spinner", {
                                key: "primary",
                                staticClass: "mr-1",
                                attrs: { variant: "primary" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.selected &&
                      _vm.selected.name &&
                      !_vm.isLoadingConfigurations
                        ? _c("ConfigList", {
                            key: _vm.selected.optionId,
                            attrs: {
                              "selected-user-id": _vm.selectedUserId,
                              config: _vm.selected,
                              application: _vm.application,
                              configurations: _vm.configurations
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("ConfigParamsContextMenu", {
        ref: "contextMenu",
        on: { action: _vm.onTreeAction }
      }),
      _c("FolderModal", {
        attrs: {
          visible: _vm.showFolderModal,
          folder: _vm.modalFolder,
          "parent-id": _vm.modalParentId,
          "children-count": _vm.modalChildrenCount
        },
        on: {
          save: _vm.onSaveComplete,
          close: function($event) {
            _vm.showFolderModal = false
          }
        }
      }),
      _c("ParameterModal", {
        attrs: {
          visible: _vm.showParameterModal,
          parameter: _vm.modalParameter,
          "parent-id": _vm.modalParentId,
          "children-count": _vm.modalChildrenCount,
          "is-copy": _vm.modalIsCopy
        },
        on: {
          save: _vm.onSaveComplete,
          close: function($event) {
            _vm.showParameterModal = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }